// import TemplateVariantDialog from './templateVariantDialog'
// import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded'
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import Typography from "@mui/material/Typography";
// import { Divider } from '@mui/material'
import { withStyles } from "@mui/styles";
import React from "react";
// import Link from 'next/link'
import { connect } from "react-redux";
// import dhl from 'public/image/couriers/dhl.svg'
// import chinaEms from 'public/image/couriers/china-ems.svg'
// import Button from '@mui/material/Button'
import TemplateSetPriceTable from "./templateSetPriceTable";

const styles = (theme) => ({
  root: {
    display: "flex",
    marginTop: 8,
  },
  left: {
    padding: "0 8px",
    height: 160,
  },
  logo: {
    width: 24,
    height: 24,
  },
  right: {
    width: "100%",
    // padding: '0 8px',
    // flex: 1,
    // display: 'flex',
    // flexDirection: 'column',
  },
  image: {
    width: 160,
    height: 160,
  },
  cell: {
    padding: "8px 0 !important",
    height: 32,
  },
  head: {
    display: "flex",
    background: "#f8f8f8",
  },
  title: {
    flex: 1,
    display: "flex",
    padding: "0 8px",
  },
  templateSetTitle: {
    fontSize: 14,
    marginTop: "auto",
    marginBottom: "auto",
    padding: "5px 0px",
  },
  info: {
    flex: 1,
    display: "flex",
    padding: "8px 0",
  },
  shipping: {
    display: "flex",
    padding: "0 8px",
    alignItems: "center",
  },
  time: {
    flex: 1,
    display: "flex",
    padding: "0 8px",
    alignItems: "center",
    // justifyContent: 'flex-end',
  },
  company: {
    // fontWeight: 400
    lineHeight: "20px",
  },
  table: {
    overflow: "auto",
  },
  // button: {
  //   display: 'flex',
  // },
});

class TemplateSetRate extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    //
  }

  render() {
    const { classes, rate } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.right}>
          <div className={classes.head}>
            <div className={classes.title}>
              <Typography variant="h6" className={classes.templateSetTitle}>
                {rate.name}
              </Typography>
            </div>
          </div>
          <div className={classes.info}>
            <div className={classes.time}>
              <AccessTimeRoundedIcon />
              <Typography variant="subtitle2" display="block">
                &nbsp;Shipping time:&nbsp;&nbsp;
              </Typography>
              <span className={classes.company}>
                {rate.min_shipping_time} - {rate.max_shipping_time} business
                days
              </span>
            </div>
          </div>
          <div className={classes.table}>
            <TemplateSetPriceTable rate={rate} />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { app, dashboard } = state;
  return { app, dashboard };
}

export default connect(mapStateToProps)(withStyles(styles)(TemplateSetRate));
